<template>
  <div class="section">
    <div class="columns is-centered">
      <div
        class="column is-full-mobile is-8-tablet is-5-desktop is-3-widescreen is-3-fullhd"
        style="text-align: center"
      >
        <h1 class="title is-4">Passwort zurücksetzten</h1>
        <div v-if="data === true" class="block">
          <b-message type="is-success">
            Wir haben Ihnen eine E-Mail geschickt um Ihr Passwort zurück zu
            setzten.
          </b-message>
        </div>
        <div v-else>
          <div v-if="error" class="block">
            <b-message type="is-danger">
              {{ error }}
            </b-message>
          </div>
          <div class="block">
            <ValidationObserver
              ref="observer"
              v-slot="{ handleSubmit, invalid }"
            >
              <div
                v-on:keyup.enter="handleSubmit(submit)"
                style="text-align: left"
              >
                <div class="block">
                  <BInputWithValidation
                    rules="required|email"
                    type="email"
                    label="E-Mail"
                    v-model="email"
                  />
                </div>

                <div class="block">
                  <b-button
                    type="is-outlined is-gold"
                    expanded
                    :disabled="invalid"
                    :loading="loading"
                    @click="handleSubmit(submit)"
                  >
                    Zurücksetzten
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'PasswordRequest',
  components: {
    BInputWithValidation,
  },
  data() {
    return {
      token: this.$route.query.token || 0,
      email: null,
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('auth/passwordRequest/PUSH', { email: this.email });
    },
  },
  computed: {
    ...mapGetters({ data: 'auth/passwordRequest/data', error: 'auth/passwordRequest/error', loading: 'auth/passwordRequest/loading' }),
  },
  mounted() {
    this.$store.commit('auth/passwordRequest/SET_DATA_CLEAR');
    this.$store.commit('auth/passwordRequest/CLEAR_ERROR');
  },
};
</script>
